export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS"
export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const GET_ALL_PRODUCTS_RESPONSE_SUCCESS = "GET_ALL_PRODUCTS_RESPONSE_SUCCESS"
